{
    "PartitionModal_AddTitle": "Ajouter une partition",
    "PartitionModal_ChangeTitle": "Modifier la partition",
    "PartitionModal_ViewTitle": "Afficher la partition",
    "PartitionModal_PromptMessage": "Vous avez des modifications de partition non enregistrées. Quitter sans enregistrer ?",
    "PartitionModal_PromptConfirm": "Sortie",
    "PartitionModal_PromptCancel": "Annuler",
    "PartitionModal_Tab_Details": "Détails",
    "PartitionModal_Tab_SiteSettings": "Paramètres du site",
    "PartitionModal_Tab_Synchronisation": "Synchronisation",
    "PartitionModal_Tab_Advanced": "Avancé",
    "PartitionModal_Tab_CommunicationStatus": "État de la synchronisation",
    "PartitionModal_Loading": "Chargement...",
    "PartitionModal_Button_Close": "Fermer",
    "PartitionModal_Button_Cancel": "Annuler",
    "PartitionModal_Button_Save": "Sauvegarder",
    "PartitionModal_RequestFailed": "La requête a échoué",
    "PartitionModal_General_Description": "Description",
    "PartitionModal_General_DescriptionRequired": "Une description est requise.",
    "PartitionModal_General_IDInTelSys": "Non dans le serveur de téléphonie (automatique)",
    "PartitionModal_General_IDInTelSysRequired": "Un numéro est requis dans le serveur de téléphonie",
    "PartitionModal_General_Tags": "Étiqueter",
    "PartitionModal_Details_Identifier": "Identifiant",
    "PartitionModal_Details_IdentifierPlaceholder": "[Attribution automatique]",
    "PartitionModal_Details_BillingIdOrTag": "Identifiant\/étiquette de facturation",
    "PartitionModal_Details_BilledMonthly": "Facturé mensuellement",
    "PartitionModal_Details_LicensedFor": "Autorisé pour",
    "PartitionModal_Details_DeleteAcdAgentsOnDowngrade": "Suppression automatique des entrées de l'agent ACD",
    "PartitionModal_LicensedFor_None": "Aucun",
    "PartitionModal_LicensedFor_AkixiLite": "Akixi Lite",
    "PartitionModal_LicensedFor_AkixiBLF": "Akixi BLF",
    "PartitionModal_LicensedFor_AkixiONE": "Akixi ONE",
    "PartitionModal_LicensedFor_Akixi1000": "Akixi 1000",
    "PartitionModal_LicensedFor_Enterprise": "Entreprise",
    "PartitionModal_LicensedFor_Akixi2000": "Akixi 2000",
    "PartitionModal_LicensedFor_Essentials": "Essentiel",
    "PartitionModal_LicensedFor_Professional": "Professionnel",
    "PartitionModal_LicensedFor_CallCentreAgent": "Agent de centre d'appels",
    "PartitionModal_LicensedFor_CallCentreSupervisor": "Superviseur de centre d'appels",
    "PartitionModal_Details_CommonDevices": "Contient des dispositifs courants",
    "PartitionModal_Details_CommonDevicesPanasonic": "Contient des périphériques courants (DP courants uniquement)",
    "PartitionModal_Details_CommunicationEnabled": "Communication activée",
    "PartitionModal_Site_Timezone": "Fuseau horaire",
    "PartitionModal_Site_StartOfDay": "Début de journée (heure locale)",
    "PartitionModal_Site_RecordingPlayback": "Lecture de l'enregistrement",
    "PartitionModal_Site_RecordingPlayback_None": "Aucun",
    "PartitionModal_Site_E164Enabled": "E.164 Activé",
    "PartitionModal_Site_InternalDigitLength": "Longueur interne des chiffres",
    "PartitionModal_Site_CountryCodeLocation": "Code pays Emplacement",
    "PartitionModal_Sync_NoSettings": "Aucun paramètre de synchronisation ne s'applique à ce type de serveur de téléphonie.",
    "PartitionModal_Sync_CommonDevicesNoSettings": "Aucun paramètre de synchronisation ne s'applique à une partition de périphériques communs.",
    "PartitionModal_Sync_NameOnTelephonyServer": "Nom sur le serveur de téléphonie",
    "PartitionModal_Sync_IDOnTelephonyServerOid": "Identifiant sur le serveur de téléphonie (OID)",
    "PartitionModal_Sync_SynchronisationTypeSoftOnly": "Type de synchronisation (logiciel uniquement)",
    "PartitionModal_Sync_EnterpriseOrProviderID": "ID d'entreprise ou de fournisseur",
    "PartitionModal_Sync_SynchronisationType": "Type de synchronisation",
    "PartitionModal_Sync_WebexEnvironmentType": "Type d'environnement Webex",
    "PartitionModal_Sync_TeamsEnvironmentType": "Type d'environnement d'équipe",
    "PartitionModal_Sync_EnterpriseID": "ID d'entreprise",
    "PartitionModal_Sync_GroupID": "ID de groupe",
    "PartitionModal_Sync_UserInLocation": "Utilisateur dans l'emplacement",
    "PartitionModal_Sync_IDOnTelephonyServer": "Identifiant sur le serveur de téléphonie",
    "PartitionModal_Sync_TypeOnTelSys": "Tapez sur Telsys",
    "PartitionModal_Sync_WebexTypeEnvironment": "environnement de type Webex",
    "PartitionModal_Sync_ComponentType_Unknown": "[Type inconnu ou non spécifié]",
    "PartitionModal_Sync_ComponentType_BroadWorks_Enterprise": "Entreprise",
    "PartitionModal_Sync_ComponentType_BroadWorks_EnterpriseGroup": "Groupe d'entreprises",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProvider": "Prestataire de services",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProviderGroup": "Groupe de prestataires de services",
    "PartitionModal_Sync_ComponentType_Webex_Organisation": "Organisation",
    "PartitionModal_Sync_ComponentType_Webex_Location": "Emplacement",
    "PartitionModal_Sync_Environment_None": "Aucun",
    "PartitionModal_Sync_Environment_Tenant": "Locataire",
    "PartitionModal_Sync_Environment_AuthoriserSelect": "Sélection de l'autorisateur",
    "PartitionModal_Sync_Environment_SecurityGroups": "Groupes de sécurité",
    "PartitionModal_Sync_SynchronisationType_Soft": "Doux",
    "PartitionModal_Sync_SynchronisationType_OneTimeFull": "Une seule fois complet",
    "PartitionModal_Sync_SynchronisationType_Full": "Complet",
    "PartitionModal_Sync_SynchronisationType_ServicePack": "Pack de services",
    "PartitionModal_Sync_SecurityGroups": "Groupes de sécurité",
    "PartitionModal_Sync_SyncOptions": "Options de synchronisation",
    "PartitionModal_Sync_SyncOptions_None": "Aucun",
    "PartitionModal_Sync_SyncOptions_Endpoints": "Points d'extrémité",
    "PartitionModal_Sync_SyncOptions_Trunking": "Transport par câbles",
    "PartitionModal_Sync_SyncOptions_Agents": "Agents + Extensions associées",
    "PartitionModal_Sync_SyncOptions_Supervisors": "superviseurs",
    "PartitionModal_Sync_MaintainParity": "Maintenir la parité",
    "PartitionModal_Sync_ForceMonitored": "Surveillance forcée",
    "PartitionModal_Sync_SupervisorPermissions": "Activer par défaut les autorisations de superviseur du serveur de téléphonie",
    "PartitionModal_Sync_SyncNow": "Synchroniser maintenant",
    "PartitionModal_Sync_PhotoSyncNow": "Synchronisation des photos maintenant",
    "PartitionModal_Advanced_CtiLoggingEnabled": "Journalisation CTI",
    "PartitionModal_Advanced_Trunking": "Transport par câbles",
    "PartitionModal_Advanced_TrunkingBurst": "Réseau de câbles (éclatement)",
    "PartitionModal_Advanced_TrunkingCapacity": "Capacité de transmission",
    "PartitionModal_Advanced_TrunkingCapacityBurst": "Capacité de transmission (éclatement)",
    "PartitionModal_Advanced_TrunkCapacity": "Capacité du coffre",
    "PartitionModal_Advanced_TrunkCapacityBurst": "Capacité du coffre (éclatement)",
    "PartitionModal_CommStatus_SyncStatusTitle": "État de la synchronisation",
    "PartitionModal_CommStatus_SyncLastStarted": "Dernière date de début :",
    "PartitionModal_CommStatus_SyncLastStarted_Placeholder": "—",
    "PartitionModal_CommStatus_SyncLastError": "État\/erreur de synchronisation",
    "PartitionModal_CommStatus_SyncLastError_Placeholder": "Aucun état de synchronisation n'est encore disponible.",
    "NAME": "PartitionModal"
}